"use client";

import type { MouseEvent, ReactNode } from "react";
import { track } from "@vercel/analytics";

export default function PublicSiteAnalyticsScope({
  children,
  className,
  page,
}: Readonly<{ children: ReactNode; className?: string; page: string }>) {
  return (
    <div
      className={className}
      onClick={(event: MouseEvent<HTMLDivElement>) => {
        const link = (event.target as Element).closest("a");
        if (!link) return;

        const href = link.getAttribute("href");
        if (!href) return;

        track(link.dataset.analyticsEvent ?? "public_page_link_click", {
          destination: href.split("?")[0],
          page,
        });
      }}
    >
      {children}
    </div>
  );
}
